import client from '../axios';

/**
 * axios used with saga
 * @returns
 */
export async function callApi({ method = 'get', url, params, data }) {
  try {
    const res = await client({
      url,
      method,
      params,
      data,
    });
    // const {
    //   resultCode,
    //   resultMessage,
    //   results,
    // } = res.data;
    const result = res.data;
    console.log('callApi res.data', res.data);

    return { result };
  } catch (e) {}
}
